<template>
  <section>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left" label-width="0px"
      class="demo-ruleForm login-container">
      <img src="./../../static/logoprincipal.png" />
      <br><br>
      <el-form-item prop="account">
        <el-input type="text" @keyup.enter.native="handleSubmit" v-model="ruleForm.account" auto-complete="off"
          placeholder="Usuário" autofocus=true></el-input>
      </el-form-item>
      <el-form-item prop="checkPass">
        <el-input type="password" @keyup.enter.native="handleSubmit" v-model="ruleForm.checkPass" auto-complete="off"
          placeholder="Senha"></el-input>
      </el-form-item>
      <el-form-item style="width:100%;">
        <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit"
          :loading="logining">Entrar</el-button>
      </el-form-item>
    </el-form>
    <div class="footer">
      Powered by <a href="https://www.mrsistemas.com.br/" target="_blank">MR Sistemas</a><br>
      © {{ (new Date().getFullYear()) }} MR SISTEMAS LTDA - Todos os Direitos reservados.
    </div>
  </section>
</template>

<script>
import { apiRequestLogin } from "../api/api";
export default {
  data () {
    return {
      logining: false,
      ruleForm: {
        account: "",
        checkPass: ""
      },
      rules: {
        account: [
          {
            required: true,
            message: "Informe o nome do usuário!",
            trigger: "blur"
          }
          //{ validator: validaePass }
        ],
        checkPass: [
          {
            required: true,
            message: "Informe a senha do usuário!",
            trigger: "blur"
          }
          //{ validator: validaePass2 }
        ]
      }
    };
  },
  methods: {
    handleSubmit () {
      // var _this = this;
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          //_this.$router.replace('/table');
          this.logining = true;
          const loginParams = {
            username: this.ruleForm.account,
            password: this.ruleForm.checkPass
          };
          apiRequestLogin(loginParams)
            .then(data => {
              // let { name, token } = data;
              localStorage.setItem("user", JSON.stringify(data));
              this.$router.push({ path: "/consulta-geral" });
            })
            .catch(error => {
              const status = error && error.response && error.response.status;
              const isTimeout = error && error.code === "ECONNABORTED";
              const isNetwork = error && !error.response;

              if (status === 401) {
                this.$message({
                  message: "Usuário/Senha inválido(s)!",
                  type: "error"
                });
              } else if (isTimeout || isNetwork) {
                this.$message({
                  message: "Falha de conexão com o servidor. Verifique sua internet e tente novamente.",
                  type: "error"
                });
              } else if (status >= 500) {
                this.$message({
                  message: "Sistema indisponível no momento! Tente novamente em alguns minutos...",
                  type: "error"
                });
              } else {
                this.$message({
                  message: "Não foi possível realizar o login. Revise os dados e tente novamente.",
                  type: "error"
                });
              }
            })
            .finally(() => {
              this.logining = false;
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.login-container {
  /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  margin: 180px auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;

  .title {
    margin: 0px auto 40px auto;
    text-align: center;
    color: #505458;
  }

  .remember {
    margin: 0px 0px 35px 0px;
  }
}

.footer {
  // height: 30px;
  height: 30px;
  line-height: 15px;
  text-align: center;
  font-size: 12px;
  float: center;
  color: #475669;
}

a:link,
a:visited {
  text-decoration: none;
  color: #475669;
}

a:hover {
  text-decoration: none;
  color: #475669;
}
</style>


// WEBPACK FOOTER //
// src/views/Login.vue